var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'grid-container': this.Setting.SearchMode == 0}},[(this.Setting.SearchMode === 0 || this.Setting.SearchMode == 1)?_c('V1LanguageTab'):_vm._e(),(this.Setting.SearchMode === 0 || this.Setting.SearchMode == 2)?_c('V1AcademicTab'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }